module.exports = __webpack_public_path__ + "static/img/4_1_4.42780c2b.jpg";